import type { AdditionalCheckFunctionType } from '../hasPermission';

export type UserHasCreditsCheckProps = {
    credits?: number;
    collectCredits?: boolean;
};

export const userHasCreditsCheck: AdditionalCheckFunctionType<UserHasCreditsCheckProps> = (props) => {
    const credits = props.payload?.credits || 0;
    const collectCredits = props.payload?.collectCredits;

    if (collectCredits) {
        return true;
    }

    return credits > 0;
};
